/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  ContentSetup,
  SavedUserState,
  ModuleState
} from '../../utils';
import { ProgressionState } from '../reducers/progression';
import { APP_CFG } from '../../appcfg';
import {
  ProblemDefinition,
  ITSEvent,
  ItsLoggerEvent
} from 'its-pages';
import { cpsRef } from './embedding-api';

const postFormData = async <Q, R>(
  url: string,
  parameters: Q
): Promise<R | undefined> => {
  const formdata = new FormData();
  formdata.append('json', JSON.stringify(parameters));
  const request = {
    method: 'POST',
    body: formdata
  };

  try {
    const response = await fetch(url, request);
    try {
      if (response.ok) {
        // don't just use response.json() because bad JSON response will 
        // always pause the debugger because it can't understand nested promises
        // where only the outside promise is caught.
        const text = await response.text();
        if (text && text[0]==='{')
        {
          const object = JSON.parse(text);
          return object;
        } else {
          return undefined;
        }
      }
    } catch { return undefined}
  } catch (err) {
    return undefined;
  }
};

// Include it as part of the APP_CFG global
export const postBugReport = async(bugReportContent: any) => {
  fetch(APP_CFG.getBugReportSrc(), {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(bugReportContent)
  });
};

export const postFluentd = async (
  event: ItsLoggerEvent,
  index: string,
  time?: number
) => {
  if (!APP_CFG.suppressFluentdLogs) {
    const url =
      APP_CFG.getServerHref('fluentd') + '.' + index + (time ? `?time=${time}` : '');

    return await postFormData<ITSEvent, ProblemQueryResponse>(url, event);
  } else {
    return;
  }
};

export const CURRENT_STATE_VERSION = 1.7;

interface ProblemQueryResponse {
  getProblem: ProblemDefinition;
}

export const saveUserState = (
  userId: string,
  state: ProgressionState,
  problemSetup: ContentSetup
) => {
  const { difficulty, progressionIndex } = problemSetup;
  const moduleState: ModuleState = {
    problemSetupState: { difficulty, progressionIndex },
    progression: state
  };
  const userState: SavedUserState = {
    stateVersion: CURRENT_STATE_VERSION,
    moduleState
  };

  cpsRef.saveUserState(userState);
};
